import React, { memo, useEffect } from 'react';
import { func, string } from 'prop-types';
import { useIntl } from 'react-intl';
import { useAnalyticsContext } from '../../../../config/GoogleTagManagerEvents';
import { MEDIA_TYPE } from '../../../../constants/screenConstants';
import useMedia from '../../../../hooks/useMedia';
import useAnalytics from '../../../../hooks/useAnalytics';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../../constants/analyticsConstants/Ecommerce';
import GuideSpot from '../../../../resources/images/guide-spot.svg';
import Button from '../button';
import './noAvailableResult.scss';

const NoAvailableResult = ({ searchQuery, onShowUnavailableClick, dataTestid, count }) => {
    const intl = useIntl();
    const mediaType = useMedia();
    const [{ payloadEcommercePageData }] = useAnalytics();
    const { sendEventsForEcommercePageData } = useAnalyticsContext();

    useEffect(() => {
        sendEventsForEcommercePageData(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_DATA,
            payloadEcommercePageData([], count)
        );
    }, []);


    return (
        <div className="no-available-result">
            <GuideSpot />
            <div className="no-available-result__content">
                <p className="center-text">
                    {intl.formatMessage({ id: 'no-available-result' })}
                    <strong>{searchQuery}</strong>
                    {mediaType === MEDIA_TYPE.MOBILE ? ' ' : <br />}
                    {intl.formatMessage({ id: 'found-near-you' })}
                </p>
                <Button
                    type="button"
                    onClick={onShowUnavailableClick}
                    className="button unvailable-btn"
                    buttonAriaLabel={intl.formatMessage({ id: 'show-unavailable-items' })}
                    dataTestid={dataTestid}>
                    {intl.formatMessage({ id: 'show-unavailable-items' })}
                </Button>
            </div>
        </div>
    );
};

NoAvailableResult.defaultProps = {
    searchQuery: '',
    onShowUnavailableClick: () => {},
    dataTestid: ''
};

NoAvailableResult.propTypes = {
    searchQuery: string,
    onShowUnavailableClick: func,
    dataTestid: string
};

export default memo(NoAvailableResult);
